import { dataLocationSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLocationSolid = /*#__PURE__*/createIcon(dataLocationSolid)
export default IconLocationSolid
